/* global Accept */
import React, { useState, useEffect } from "react";
import { Field, Form, Formik } from "formik";
import { ImCreditCard } from "react-icons/im";
import { FaCheckCircle } from "react-icons/fa";
import { IoDiamond } from "react-icons/io5";
import { BsBank } from "react-icons/bs";
import * as Yup from "yup";
import PopupError from "./PopupError";
import { loadAuthorizeScript } from "../../utils/loadAuthorize";
import { addPaymentInfo } from "../../services/publicApi";

const AUTH_CLIENT_KEY = process.env.REACT_APP_AUTHNET_CLIENT_KEY;
const AUTH_LOGIN_ID = process.env.REACT_APP_AUTHNET_LOGIN_ID;

const PaymentForms = (
{
  totalAmt,
  discountAmt,
  sub,
  finalrender,
  setUserSaved,
}) => {

  const validationSchemaCard = Yup.object({
    cardNumber: Yup.string().required("Card number is required"),
    expireDate: Yup.string().required("Expiry date is required"),
    securityCode: Yup.string().required("Security code is required"),
  });

  const validationSchemaGPay = Yup.object({
    upiId: Yup.string().required("UPI ID is required"),
    phoneNumber: Yup.string().required("Phone number is required"),
  });

  const validationSchemaNeft = Yup.object({
    accountNumber: Yup.string().required("Account number is required"),
    routingNumber: Yup.string().required("Routing number is required"),
    nameOnAcc: Yup.string().required("Name on account is required"),
    bankName: Yup.string().required("Bank name is required"),
    bankAddress: Yup.string().required("Bank address is required"),
  });

  const [cardPayVisible, setCardPayVisible] = useState(true);
  const [gPayVisible, setGPayVisible] = useState(false);
  const [neftPayVisible, setNeftPayVisible] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("CD");
  const [payThroughVisible, setPayThroughVisible] = useState(true);
  const [redeemVisible, setRedeemVisible] = useState(false);
  const [payFormData, setPayFormData] = useState({
    cardNumber: "",
    expireDate: "",
    securityCode: "",
    upiId: "",
    phoneNumber: "",
    accountNumber: "",
    routingNumber: "",
    nameOnAcc: "",
    bankName: "",
    bankAddress: "",
  });
  const initialValuesPayment = payFormData;
  const [cuserid, setCuserid] = useState("");
  const [showError, setShowError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [ccErrorCount, setCCErrorCount] = useState(0);
  const [dateErrorCount, setDateErrorCount] = useState(0);
  const [errPopupVisible, setErrPopupVisible] = useState(false);
  const [popUpErrType, setPopUpErrType] = useState("");
  const [popUpErrMsg, setPopUpErrMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    loadAuthorizeScript();
  }, []);  


  useEffect(() => {
    const savedState = sessionStorage.getItem("cuserid");
    if (savedState) {
      try {
        const parsedSavedState = JSON.parse(savedState);
        setCuserid(parsedSavedState);
      } catch (error) {
        console.error("Error parsing savedState:", error);
      }
    }
  }, []);
  

  const handleNumberKeyPress = (event) => {
    const charCode = event.which || event.keyCode;
    const inputValue = event.target.value;

    if (charCode < 48 || charCode > 57 || inputValue.length >= 10) {
      event.preventDefault();
    }
  };
  const handleLetterKeyPress = (event) => {
    const charCode = event.which || event.keyCode;
    const inputValue = event.target.value;

    if (
      !(
        (charCode >= 65 && charCode <= 90) ||
        (charCode >= 97 && charCode <= 122) ||
        charCode === 32
      ) ||
      inputValue.length >= 50
    ) {
      event.preventDefault();
    }
  };

  const handleNumberOnlyKeyPress = (event) => {
    const charCode = event.which || event.keyCode;
    const inputValue = event.target.value;

  // Allow only numbers + max 3 digits
  if (charCode < 48 || charCode > 57 || inputValue.length >= 3) {
    event.preventDefault();
  }
  };

  const handleInput = (event) => {
    const cleanedValue = event.target.value.replace(/\s/g, "");
    event.target.value = formatCardNumber(cleanedValue);
  };

  const handleCreditBlur = (event) => {
    const cleanedValue = event.target.value.replace(/\s/g, "");
    event.target.value = formatCardNumber(cleanedValue);
    if (!isValidCardNumber(cleanedValue) && cleanedValue !== "") {
      setCCErrorCount(1);
      setErrPopupVisible(true);
      setPopUpErrType("Invalid card number");
      setPopUpErrMsg("Please enter a valid credit card number");
    } else {
      setCCErrorCount(0);
      setErrPopupVisible(false);
    }
  };

  const formatCardNumber = (inputValue) => {
    let cleanedValue = inputValue.replace(/\D/g, "");
    if (/^3[47]\d{13}$/.test(cleanedValue)) {
      return cleanedValue
        .replace(/^(\d{4})(\d{6})(\d{5})$/, "$1 $2 $3")
        .slice(0, 17);
    }
    return cleanedValue.replace(/(\d{4})(?=\d)/g, "$1 ").slice(0, 19);
  };

  const isValidCardNumber = (cardNumber) => {
    const patterns = [
      /^4\d{12}(\d{3})?$/, // Visa
      /^5[1-5]\d{14}$/, // MasterCard
      /^6(?:011|5\d{2})\d{12}$/, // Discover
      /^3[47]\d{13}$/, // American Express
      /^3(?:0[0-5]|[68]\d)\d{11}$/, // Diners Club
      /^(?:2131|1800|35\d{3})\d{11}$/, // JCB
    ];

    return patterns.some((pattern) => pattern.test(cardNumber));
  };

  const dateValidation = (value) => {
    const inputValueMonth = value.replace("/", "").slice(0, 2);
    const inputValueYear = value.replace("/", "").slice(2);
    const currentMonth = new Date()
      .toLocaleDateString("en-US", {
        month: "2-digit",
      })
      .replace(/\//g, "");
    const currentYear = new Date()
      .toLocaleDateString("en-US", {
        year: "2-digit",
      })
      .replace(/\//g, "");

    if (value.length === 2 && inputValueMonth > 12) {
      setErrPopupVisible(true);
      setPopUpErrType("Invalid month");
      setPopUpErrMsg("Please enter a valid month");
    } else if (inputValueYear && currentYear > inputValueYear) {
      setErrPopupVisible(true);
      setPopUpErrType("Invalid Year");
      setPopUpErrMsg("Please enter a valid Year");
      setDateErrorCount(1);
    } else if (
      currentMonth === inputValueMonth &&
      currentYear === inputValueYear
    ) {
      setErrPopupVisible(true);
      setPopUpErrType("Invalid Date");
      setPopUpErrMsg("Please enter a valid Date");
      setDateErrorCount(1);
    } else if (value.length > 0 && value.length < 4) {
      setErrPopupVisible(true);
      setPopUpErrType("Invalid date");
      setPopUpErrMsg("Please enter a valid date");
      setDateErrorCount(1);
    } else {
      setDateErrorCount(0);
      setErrPopupVisible(false);
    }
  };

  const handleDateBlur = (event) => {
    const inputValue = event.target.value.replace("/", "");
    dateValidation(inputValue);
  };

  const handleDateKeyPress = (event) => {
    const charCode = event.which;
    const inputValue = event.target.value.replace("/", "");
    const isNumber = charCode >= 48 && charCode <= 57;
    const isSlash = charCode === 47;

    if (!isNumber && !isSlash) {
      event.preventDefault();
      return;
    }

    if (inputValue.length >= 4) {
      event.preventDefault();
      return;
    }

    if (isSlash && inputValue.length < 2) {
      event.preventDefault();
      return;
    }

    if (inputValue.includes("/") && isSlash) {
      event.preventDefault();
      return;
    }

    if (isNumber && inputValue.length === 2 && !inputValue.includes("/")) {
      event.target.value = inputValue + "/";
    }

    const enteredMonth = parseInt(inputValue, 10);
    if (inputValue.length === 2 && enteredMonth > 12) {
      setErrPopupVisible(true);
      setPopUpErrType("Invalid month");
      setPopUpErrMsg("Please enter a valid month");
      event.preventDefault();
    } else {
      setErrPopupVisible(false);
    }
  };

  const handleRoutingNumberKeyPress = (event) => {
    const charCode = event.which || event.keyCode;
    const inputValue = event.target.value;

    if (charCode < 48 || charCode > 57 || inputValue.length >= 9) {
      event.preventDefault();
    }
  };

  const handleAccNumberKeyPress = (event) => {
    const charCode = event.which || event.keyCode;
    const inputValue = event.target.value;

    if (charCode < 48 || charCode > 57 || inputValue.length >= 25) {
      event.preventDefault();
    }
  };

  const handeleCardPay = () => {
    setCardPayVisible(true);
    setPaymentMethod("CD");
    setGPayVisible(false);
    setNeftPayVisible(false);
  };
  const handleGpay = () => {
    setCardPayVisible(false);
    setGPayVisible(true);
    setPaymentMethod("GPay");
    setNeftPayVisible(false);
  };
  const handleNeftPay = () => {
    setCardPayVisible(false);
    setGPayVisible(false);
    setNeftPayVisible(true);
    setPaymentMethod("NB");
  };

  const handlePaymentSubmit = async (value) => {
    try {
      setIsLoading(true); 
      console.log(value, "Value");
  
      if (paymentMethod === "CD") {
        const ccNo = value.cardNumber?.replace(/\s+/g, "");
        const formattedExpiry = value.expireDate?.replace("/", "");
        const cvv = value.securityCode;
  
      if (!ccNo || ccNo.length < 12) {
        alert("Invalid card number");
        return;
      }
      if (!/^(0[1-9]|1[0-2])\d{2}$/.test(formattedExpiry)) {
        alert("Invalid expiry date");
        return;
      }
      if (!cvv || cvv.length < 3) {
        alert("Invalid CVV");
        return;
      }
  
        const authData = {
          clientKey: AUTH_CLIENT_KEY,
          apiLoginID: AUTH_LOGIN_ID,
        };        
        
        const cardData = {
          cardNumber: ccNo,
          month: formattedExpiry.slice(0, 2),
          year: "20" + formattedExpiry.slice(2),
          
        };
  
        const secureData = { cardData, authData };
        console.log(secureData,"secureData");

        if (!window.Accept) {
          alert("Payment system still loading. Please wait 2 seconds and try again.");
          return;
        }        
  
        Accept.dispatchData(secureData, async (response) => {
          console.log(response, "Accept Response");
  
          if (response.messages.resultCode === "Error") {
            const errorMsg = response.messages.message[0].text;
            console.error("Payment Error:", errorMsg);
            alert(`Error: ${errorMsg}`);
            return;
          }
  
          const { dataDescriptor, dataValue } = response.opaqueData;
  
          try {
            const formdataToSend = buildFormData(value, ccNo, formattedExpiry);
            console.log(dataDescriptor,"dataDescriptor");
            console.log(dataValue,"token");

            await submitPayment({
              ...formdataToSend,
              descriptor: dataDescriptor,
              token: dataValue,
            });
  
            
            setIsLoading(false); 
            handlePaymentSuccess(); 
          } catch (err) {
            console.error(err);
            setIsLoading(false);
            setShowError(true);
            setErrorMsg("Backend card payment failed");
            
          }
        });
      } else if (paymentMethod === "NB") {
        // NETBANKING FLOW
        try {
          const formdataToSend = buildFormData(value, "", "");

          await submitPayment({
            ...formdataToSend,
            method: "NetBanking",
            bankName: value.bankName || "", 
            accountNumber: value.accountNumber || "",
            ifscCode: value.ifscCode || "",
          });
          setIsLoading(false); 
          handlePaymentSuccess(); 

        } catch (err) {
          setIsLoading(false);
          handlePaymentError(err);
          console.error("NetBanking error:", err);
        
        }
      } else if (paymentMethod === "GPay") {

        try {
          await submitPayment({ method: "GPay", upiId: value.upiId || "" });
          setIsLoading(false); 
          handlePaymentSuccess(); 
        } catch (err) {
          console.error("GPay error:", err);
        }
      }
    } catch (error) {
      console.error("handlePaymentSubmit error:", error);
      setIsLoading(false);
      setShowError(true);
      setErrorMsg("Something went wrong");
      
    }
  };

  const isFormValid = (ccNo, expireDate) => {
    if (dateErrorCount !== 0) {
      dateValidation(expireDate);
      return false;
    }

    if (ccErrorCount !== 0) {
      formatCardNumber(ccNo);
      if (!isValidCardNumber(ccNo) && ccNo !== "") {
        setErrPopupVisible(true);
        setPopUpErrType("Invalid card number");
        setPopUpErrMsg("Please enter a valid credit card number");
        return false;
      } else {
        setErrPopupVisible(false);
      }
    }

    return sub.length > 0;
  };

  const buildFormData = (value, ccNo, expireDate) => ({
    cuserid: cuserid,
    cid: sub,
    paymenttype: paymentMethod,
    ccno: ccNo,
    expiresOn: expireDate,
    cvv: value?.securityCode,
    accountnumber: value?.accountNumber,
    routingno: value?.routingNumber,
    nameofacc: value?.nameOnAcc,
    bankname: value?.bankName,
    amountCharged: totalAmt,
  });

  const submitPayment = async (formdataToSend) => {
    try {
      const res = await addPaymentInfo(cuserid, formdataToSend);
      return res.data;
    } catch (error) {
      console.error("Payment error:", error.response?.data || error.message);
      throw error;
    }
  };
  

  const handlePaymentSuccess = () => {
    setUserSaved(false);
    setPayThroughVisible(false);
    setRedeemVisible(true);
    setShowError(false);

    setTimeout(() => {
      setRedeemVisible(false);
      finalrender("Transaction completed succeccfully");
      resetPaymentForm();
    }, 5000);
  };

  const handlePaymentError = (error) => {
    setUserSaved(false);
    setPayThroughVisible(true);

    if (error) {
      setShowError(true);

      if (error?.response?.data?.message) {
        setErrorMsg(error.response.data.message);
      } else if (
        error?.response?.data?.details ||
        error?.response?.data?.error
      ) {
        setErrorMsg(`${error.response.data.error}`);
      } else {
        setErrorMsg("Something went wrong");
      }

      console.log("error:", error.response.data);
    } else {
      setShowError(false);
    }
  };

  // 🔹 Form reset
  const resetPaymentForm = () => {
    setPaymentMethod("CD");
    setPayFormData({
      cardNumber: "",
      expireDate: "",
      securityCode: "",
      upiId: "",
      phoneNumber: "",
      accountNumber: "",
      routingNumber: "",
      nameOnAcc: "",
      bankName: "",
      bankAddress: "",
    });
  };

  return (
    <>
      <div>
        {errPopupVisible ? (
          <PopupError
            errType={popUpErrType}
            errMsg={popUpErrMsg}
            onClose={() => {
              setErrPopupVisible(false);
              setPopUpErrType("");
              setPopUpErrMsg("");
            }}
          />
        ) : null}
      </div>

      {payThroughVisible && (
        <div className="payment-content">
          <div className="payment-through">
            <div className="payment-top-content">
              <h4>
                We'll only use this if you continue after your trial ends!
              </h4>
            </div>
            <div className="payment-start-content">
              <h6>
                <IoDiamond/>
                Diamond - 6 months :{" "}
                <span
                  style={{
                    color: "#f5a425",
                    fontWeight: 700,
                    fontSize: "15px",
                  }}
                >
                  {` $ ${Number(totalAmt).toFixed(2)} / 6 months`}
                </span>
              </h6>

              <div className="select-payment-method">
                <ImCreditCard
                  type="radio"
                  className={`pay-logo ${cardPayVisible ? "selected" : ""}`}
                  onClick={handeleCardPay}
                />

                {/* <FaGooglePay
                  type="radio"
                  style={{ fontSize: "38px" }}
                  className={`pay-logo ${gPayVisible ? "selected" : ""}`}
                  onClick={handleGpay}
                /> */}

                <BsBank
                  type="radio"
                  className={`pay-logo ${neftPayVisible ? "selected" : ""}`}
                  onClick={handleNeftPay}
                />
              </div>
            </div>

            {/* card payment  */}

            {cardPayVisible && (
              <div className="card-form">
                <Formik
                  enableReinitialize={true}
                  validationSchema={validationSchemaCard}
                  initialValues={initialValuesPayment}
                  onSubmit={handlePaymentSubmit}
                >
                  {({ touched, errors }) => (
                    <Form>
                      <div
                        className="row"
                        style={{
                          textAlign: "left",
                          color: "white",
                        }}
                      >
                        <div className="col-md-12">
                          <fieldset>
                            <label htmlFor="cardNumber">Card Number</label>
                            <br />
                            <Field
                              type="text"
                              className="form-control"
                              placeholder="Please enter your card number"
                              name="cardNumber"
                              onInput={handleInput}
                              onBlur={handleCreditBlur}
                            />
                            {touched.cardNumber && errors.cardNumber && (
                              <div className="errorMessage">
                                {errors.cardNumber}
                              </div>
                            )}
                          </fieldset>
                        </div>
                        <div className="col-md-6">
                          <fieldset>
                            <label htmlFor="expireDate">Expires on</label>
                            <br />
                            <Field
                              type="text"
                              className="form-control"
                              placeholder="MM / YY"
                              name="expireDate"
                              onKeyPress={handleDateKeyPress}
                              onBlur={handleDateBlur}
                            />

                            {touched.expireDate && errors.expireDate && (
                              <div className="errorMessage">
                                {errors.expireDate}
                              </div>
                            )}
                          </fieldset>
                        </div>
                        <div className="col-md-6">
                          <fieldset>
                            <label htmlFor="securityCode">Security Code</label>
                            <br />
                            <Field
                              type="text"
                              className="form-control"
                              placeholder="Please enter your security code"
                              name="securityCode"
                              onKeyPress={handleNumberOnlyKeyPress}
                            />
                            {touched.securityCode && errors.securityCode && (
                              <div className="errorMessage">
                                {errors.securityCode}
                              </div>
                            )}
                          </fieldset>
                        </div>
                      </div>
                      <div className="payment-end-content">
                        <p>
                          You will save{" "}
                          <span
                            style={{
                              color: "#f5a425",
                              fontWeight: 700,
                              fontSize: "15px",
                            }}
                          >
                            {` $ ${Number(discountAmt).toFixed(2)}`}
                          </span>{" "}
                          compared to the monthly plan. Recurring billing.
                          Cancel anytime
                        </p>
                        <div className="col-md-12">
                          <fieldset>
                            <button
                              type="submit"
                              id="form-submit"
                              className="button"
                              disabled={isLoading} 
                            >
                              {isLoading ? (
                                <span className="loading-spinner">
                                  <i className="fa fa-spinner fa-spin"></i> Processing...
                                </span>
                              ) : (
                                "Start my free week"
                              )}
                            </button>
                          </fieldset>
                        </div>
                        <div>
                          {cardPayVisible && showError ? (
                            <div className="paymentError">{errorMsg}</div>
                          ) : null}
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            )}

            {/* G pay  */}
            {/* {gPayVisible && (
              <div className="card-form">
                <Formik
                  enableReinitialize={true}
                  validationSchema={validationSchemaGPay}
                  initialValues={initialValuesPayment}
                  onSubmit={handlePaymentSubmit}
                >
                  {({ touched, errors }) => (
                    <Form>
                      <div
                        className="row"
                        style={{
                          textAlign: "left",
                          color: "white",
                        }}
                      >
                        <div className="col-md-12">
                          <fieldset>
                            <label htmlFor="upiId">UPI ID</label>
                            <br />
                            <Field
                              type="text"
                              className="form-control"
                              placeholder="Please enter your UPI ID"
                              name="upiId"
                            />
                            {touched.upiId && errors.upiId && (
                              <div className="errorMessage">{errors.upiId}</div>
                            )}
                          </fieldset>
                        </div>
                        <div className="col-md-12">
                          <fieldset>
                            <label htmlFor="phoneNumber">Phone number</label>
                            <br />
                            <Field
                              type="text"
                              className="form-control"
                              placeholder="Please enter your Phone number"
                              name="phoneNumber"
                              onKeyPress={handleNumberKeyPress}
                            />
                            {touched.phoneNumber && errors.phoneNumber && (
                              <div className="errorMessage">
                                {errors.phoneNumber}
                              </div>
                            )}
                          </fieldset>
                        </div>
                      </div>
                      <div className="payment-end-content">
                        <p>
                          You will save{" "}
                          <span
                            style={{
                              color: "#f5a425",
                              fontWeight: 700,
                              fontSize: "15px",
                            }}
                          >
                            {` $ ${Number(discountAmt).toFixed(2)}`}
                          </span>{" "}
                          compared to the monthly plan. Recurring billing.
                          Cancel anytime
                        </p>
                        <div className="col-md-12">
                          <fieldset>
                            <button
                              type="submit"
                              id="form-submit"
                              className="button"
                              disabled={isLoading} 
                            >
                              {isLoading ? (
                                <span className="loading-spinner">
                                  <i className="fa fa-spinner fa-spin"></i> Processing...
                                </span>
                              ) : (
                                "Start my free week"
                              )}
                            </button>
                          </fieldset>
                        </div>
                        <div>
                          {gPayVisible && showError ? (
                            <div className="paymentError">
                              <p>{errorMsg}</p>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            )} */}

            {/* NEFT  */}
            {neftPayVisible && (
              <div className="card-form">
                <Formik
                  enableReinitialize={true}
                  validationSchema={validationSchemaNeft}
                  initialValues={initialValuesPayment}
                  onSubmit={handlePaymentSubmit}
                >
                  {({ touched, errors }) => (
                    <Form>
                      <div
                        className="row"
                        style={{
                          textAlign: "left",
                          color: "white",
                        }}
                      >
                        <div className="col-md-6">
                          <fieldset>
                            <Field
                              name="accountNumber"
                              type="text"
                              placeholder="Account number"
                              className="form-control"
                              onKeyPress={handleAccNumberKeyPress}
                            />
                            {touched.accountNumber && errors.accountNumber && (
                              <div className="errorMessage">
                                {errors.accountNumber}
                              </div>
                            )}
                          </fieldset>
                        </div>
                        <div className="col-md-6">
                          <fieldset>
                            <Field
                              name="routingNumber"
                              type="text"
                              placeholder="Routing number"
                              className="form-control"
                              onKeyPress={handleRoutingNumberKeyPress}
                            />
                            {touched.routingNumber && errors.routingNumber && (
                              <div className="errorMessage">
                                {errors.routingNumber}
                              </div>
                            )}
                          </fieldset>
                        </div>
                        <div className="col-md-6">
                          <fieldset>
                            <Field
                              name="nameOnAcc"
                              type="text"
                              placeholder="Name on account"
                              className="form-control"
                              onKeyPress={handleLetterKeyPress}
                            />
                            {touched.nameOnAcc && errors.nameOnAcc && (
                              <div className="errorMessage">
                                {errors.nameOnAcc}
                              </div>
                            )}
                          </fieldset>
                        </div>
                        <div className="col-md-6">
                          <fieldset>
                            <Field
                              name="bankName"
                              type="text"
                              placeholder="Bank name"
                              className="form-control"
                              onKeyPress={handleLetterKeyPress}
                            />
                            {touched.bankName && errors.bankName && (
                              <div className="errorMessage">
                                {errors.bankName}
                              </div>
                            )}
                          </fieldset>
                        </div>
                        <div className="col-md-12">
                          <fieldset>
                            <Field
                              name="bankAddress"
                              type="text"
                              placeholder="Bank address"
                              className="form-control"
                            />
                            {touched.bankAddress && errors.bankAddress && (
                              <div className="errorMessage">
                                {errors.bankAddress}
                              </div>
                            )}
                          </fieldset>
                        </div>
                      </div>
                      <div className="payment-end-content">
                        <p>
                          You will save{" "}
                          <span
                            style={{
                              color: "#f5a425",
                              fontWeight: 700,
                              fontSize: "15px",
                            }}
                          >
                            {` $ ${Number(discountAmt).toFixed(2)}`}
                          </span>{" "}
                          compared to the monthly plan. Recurring billing.
                          Cancel anytime
                        </p>
                        <div className="col-md-12">
                          <fieldset>
                            <button
                              type="submit"
                              id="form-submit"
                              className="button"
                              disabled={isLoading} 
                            >
                              {isLoading ? (
                                <span className="loading-spinner">
                                  <i className="fa fa-spinner fa-spin"></i> Processing...
                                </span>
                              ) : (
                                "Start my free week"
                              )}
                            </button>
                          </fieldset>
                        </div>
                        <div>
                          {neftPayVisible && showError ? (
                            <div className="paymentError">
                              <p>{errorMsg}</p>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            )}
          </div>
        </div>
      )}

{redeemVisible && (
  <div
    className="payment-content"
    style={{
      background: "rgba(255, 255, 255, 0.1)",
      padding: "20px 10px",
      borderRadius: "10px",
      boxShadow: "0 8px 30px rgba(0, 0, 0, 0.3)",
      maxWidth: "550px",
      width: "100%",
    }}
  >
      <div className="payment-top-content" style={{ marginBottom: "20px" }}>
        <h1 style={{ fontSize: "37px", marginLeft: "50px", color: "#ffff" }}>Verification Completed</h1>
      </div>

      {/* Tick Animation */}
       <div
            className="tick"
            style={{
              margin: "10px 0",
              height: "180px",
            }}
          >
            {/* <Tick size={150} /> */}
            <FaCheckCircle size={150} color="#4CAF50" />
          </div>

        <p style={{ fontSize: "16px",  marginLeft: "100px", color: "#ffff"}}>
          Thank you for subscribing <strong style={{color: "#f5a425",}}>Nextestify</strong> !
        </p>
        <p style={{ fontSize: "16px",marginLeft: "100px",  color: "#ffff" }}>
          Your subscription is active for the next <strong>6 months</strong>.
        </p>
        <p style={{ fontSize: "16px", color: "#f5a425", fontWeight: 600, marginLeft: "100px" }}>
          Enjoy trial features for 7 days!
        </p>
      </div>
      )}
    </>
  );
};

export default PaymentForms;
